export default "__VITE_ASSET__RNc6IJL1__";